import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js'
import { PricePlanTypeEnum } from 'common/enums/PricePlanTypeEnum'
import { PaidCalendarPaymentButtonProps } from 'common/types/entities/booking-paid-calendar-interface'
import { BorderType } from 'common/types/styleTypes'
import FieldErrors from 'publisher/components/FieldErrors'
import {
  handleCaptureOrder,
  handleValidateSubscription,
  usePaypalRestPaymentHandler,
} from 'publisher/hooks/payment/use-paypal-rest-payment-handler'
import useManagement from 'publisher/hooks/useManagement'
import { selectors as managementSelectors } from 'publisher/reducers/managementReducer'
import { usePayment } from 'publisher/store'
import {
  getActivePricePlan,
  getOfferCurrency,
  isOrderBumpChecked,
} from 'publisher/store/payment/paymentSelectors'
import React from 'react'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'
import { PaypalBackgroundColorType } from 'src/shared/schemas/payment/paypal-background-color.schema'

export interface PaypalRestPaymentButtonProps {
  entity: PaymentButtonEntityInterface
  backgroundColor?: PaypalBackgroundColorType
  borderRadius?: Partial<BorderType>
}

export const PaidCalendarPaypalRestPaymentButton = ({
  entity,
  commonStyles,
}: PaidCalendarPaymentButtonProps) => {
  const pricePlan = usePayment(getActivePricePlan)
  const offerCurrency = usePayment(getOfferCurrency)
  const { handleSubmit, errors, isLoading, orderHash } =
    usePaypalRestPaymentHandler(entity)
  const isBumpChecked = usePayment(isOrderBumpChecked)
  const isPreview = useManagement(managementSelectors.isPreviewMode)

  const isSubscription = pricePlan?.type !== PricePlanTypeEnum.OneShot

  const paypalOptions = {
    clientId: `${process.env.PAYPAL_CLIENT_ID}`,
    currency: offerCurrency.toLocaleUpperCase(),
    ...(isSubscription && { vault: true, intent: 'subscription' }),
  }

  const createPayment = async () => (await handleSubmit()) as string
  const onApprove = async (data: any) => {
    if (isSubscription) {
      await handleValidateSubscription(data, orderHash, isBumpChecked)
    } else {
      await handleCaptureOrder(data, orderHash, isBumpChecked)
    }
  }
  return (
    <PayPalScriptProvider options={paypalOptions}>
      <PayPalButtons
        {...(isSubscription
          ? { createSubscription: createPayment }
          : { createOrder: createPayment })}
        onApprove={onApprove}
        disabled={isLoading || isPreview}
        style={{
          layout: 'horizontal',
          label: 'paypal',
          shape: 'rect',
          disableMaxWidth: true,
          borderRadius: 5,
          color: 'blue',
        }}
        forceReRender={[commonStyles]}
        message={{}}
      />
      <FieldErrors errors={errors} align="center" />
    </PayPalScriptProvider>
  )
}
